export default {
  technicalIssue:
    'Please try again, a technical issue occurred. If you continue to experience difficulties you can order by phone at 1-800-289-6229.',
  callCenterJewelryMessage: 'Have a question? Talk with our fine jewelry experts at <strong>1-800-388-6229.</strong>',
  callCenterJewelryUnavailableMessageMCOM: 'Have a question? Talk with our fine jewelry experts at <strong>1-800-249-7955.</strong>',
  callCenterBigTicketUnavailableMessageMCOM: 'Have a question? Talk with our furniture & mattress experts at <strong>1-800-230-2314.</strong>',
  callCenterBigTicketMessageMCOM: 'Have a question? Talk with our furniture & mattress experts at <strong>1-800-366-6229</strong>.',
  callCenterBeautyUnavailableMessageMCOM: 'Have a question or need advice? Call one of our beauty pros at <strong>1-800-247-3520</strong>.',
} as const;
